import type { Optional } from '@festina-life/core'

const versionFileName =
  (extension: string) => (mappingId: string, from: Optional<string>) =>
    `${[mappingId, from].filter(Boolean).join('-')}.${extension}`

export const glMapExcelFileName = versionFileName('xlsx')
export const glMapJsonFileName = versionFileName('json')
